module.exports = __webpack_public_path__ + "main/assets/public/player-media-session/playing-192.0c666b6af3ade4ec.jpg";